import { appInfo } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
            <div className="w-full lg:w-1/2 flex justify-center">
              <div className="w-48 md:w-56 aspect-[3/5] rounded-3xl overflow-hidden bg-background-200 border-4 border-background-50">
                <img
                  src={appInfo.image}
                  alt="海角网 App 界面展示"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            <div className="w-full lg:w-1/2 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                {appInfo.title}
              </h2>
              <p className="mt-2 text-lg text-primary-500 font-heading">
                {appInfo.subtitle}
              </p>
              <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                {appInfo.desc}
              </p>
              <ul className="mt-5 space-y-2">
                {appInfo.features.map((f, idx) => (
                  <li key={idx} className="flex items-center justify-center lg:justify-start gap-2 text-sm text-foreground-600">
                    <i className="ri-checkbox-circle-fill text-primary-500 text-base"></i>
                    {f}
                  </li>
                ))}
              </ul>
              <div className="flex flex-col sm:flex-row items-center lg:items-start gap-3 mt-6">
                <a
                  href="#"
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-white text-sm font-medium rounded-full cursor-pointer hover:bg-foreground-800 transition-colors whitespace-nowrap"
                >
                  <i className="ri-apple-fill text-lg"></i>
                  App Store 下载
                </a>
                <a
                  href="#"
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-white text-sm font-medium rounded-full cursor-pointer hover:bg-foreground-800 transition-colors whitespace-nowrap"
                >
                  <i className="ri-android-fill text-lg"></i>
                  Android 下载
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}